import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ThemeContext } from 'styled-components';
import FeedbackContext from '../components/feedbackContext/FeedbackContext';
import feedbackOnStageUtils from './feedbackOnStageUtils';

const useCopied = () => {
    const { setFeedbackOnStage } = useContext(FeedbackContext);
    const [copySuccess, setCopySuccess] = useState(false);
    const theme = useContext(ThemeContext);
    const intl = useIntl();

    const copyToClipboard = async ({ valueCopied, labelCopied }) => {
        if (typeof window === 'undefined') return false;
        try {
            if (
                typeof window.ClipboardItem === 'undefined' ||
                typeof window.navigator?.clipboard?.write !== 'function'
            ) {
                throw new Error('Clipboard unavailable');
            }

            const isImage = valueCopied.startsWith('data:image/png');

            let blob;

            if (isImage) {
                const fetchValue = await fetch(valueCopied);
                blob = await fetchValue.blob();
            } else {
                blob = new Blob([valueCopied], { type: 'text/plain' });
            }

            const blobType = isImage ? 'image/png' : 'text/plain';
            const data = [new window.ClipboardItem({ [blobType]: blob })];

            await window.navigator.clipboard.write(data);
            setCopySuccess(true);
            setFeedbackOnStage(
                feedbackOnStageUtils.colorCopied(labelCopied || valueCopied, theme, intl),
            );
            return true;
        } catch {
            setCopySuccess(false);
            setFeedbackOnStage(
                feedbackOnStageUtils.colorNotCopied(labelCopied || valueCopied, theme, intl),
            );
            return false;
        }
    };

    useEffect(() => {
        let timer;
        if (copySuccess) {
            timer = setTimeout(() => {
                setCopySuccess(false);
            }, 1100);
        }
        return () => clearTimeout(timer);
    }, [copySuccess]);

    return { copyToClipboard, copySuccess };
};

export default useCopied;
